import "core-js/modules/es.array.push.js";
import { ref, shallowRef } from '@vue/reactivity';
import AMapLoader from '@amap/amap-jsapi-loader';
import moment from 'moment';
import Config from '@/config';
import { showConfirmDialog, showDialog } from 'vant';
import GeocoderUtil from '@/utils/GeocoderUtil';
import CommonUtil from '@/utils/CommonUtil';
import AssetsUtil from '@/utils/AssetsUtil';
import RouterUtil from '@/utils/RouterUtil';
import SessionUtil from '@/utils/SessionUtil';
import ReserveForm from '@/view/components/reserve-form/reserve-form.vue';
import TipForm from '@/view/components/tip-form/tip-form.vue';
import ProxyForm from '@/view/components/proxy-form/proxy-form.vue';
import StorageUtil from '@/utils/StorageUtil';
import SettingApi from '@/api/setting-api';
import OrderApi from '@/api/order-api';
export default {
  name: 'OrderInitiate',
  components: {
    ProxyForm,
    TipForm,
    ReserveForm
  },
  computed: {
    CommonUtil() {
      return CommonUtil;
    }
  },
  setup() {
    const noQueryAddress = shallowRef(false);
    const map = shallowRef();
    const geolocation = shallowRef();
    const geocoder = shallowRef();
    const weather = shallowRef();
    const driving = shallowRef();
    const vehicleTypes = ref({
      'ORDER_CAR_TYPE_NORMAL_TAXI': {
        icon: require('@/assets/icon/vehicle/taxi.png'),
        name: '出租车',
        description: '传统出租 接单快速',
        pricePrefix: '预估',
        discount: 1.0,
        checked: true
      }
      // "ORDER_CAR_TYPE_ONLINE_TAXI": {
      //   icon: require('@/assets/icon/vehicle/taxi-new.png'),
      //   name: "新出租", description: "线上价格 超值畅行", pricePrefix: "预估",
      //   discount: 0.9,
      //   checked: false,
      // },
    });
    const vehiclePrices = ref({
      'ORDER_CAR_TYPE_NORMAL_TAXI': 0
      // "ORDER_CAR_TYPE_ONLINE_TAXI": 0,
    });
    const tolls = ref(0);
    const position = ref(Config.defaultPosition);
    const cityName = ref('');
    const cityCode = ref('');
    const lastCityCode = ref('');
    const orderCityCode = ref('');
    const showWeather = ref(false);
    const cityWeather = ref('');
    const cityWeatherIcon = ref(require('@/assets/icon/weather/default.svg'));
    const userData = ref();
    const calling = ref(false);
    const callErrorCount = ref(0);
    const startAddress = ref('');
    const startPosition = ref([]);
    const endAddress = ref('您要去哪里？');
    const endPosition = ref([]);
    const paidPickUp = ref(false);
    const kilometer = ref('--');
    const drivingTime = ref('--');
    const reserve = ref(false);
    const showReserveForm = ref(false);
    const reserveDay = ref(0);
    const reserveDate = ref();
    const reserveTime = ref(['12', '00']);
    const tip = ref(false);
    const showTipForm = ref(false);
    const tipAmount = ref();
    const proxy = ref(false);
    const showProxyForm = ref(false);
    const proxyPriorityContactPassenger = ref(true);
    const proxyPassengerMobile = ref('');
    const proxyPassengerName = ref('');
    const setting = ref({});
    const isMorningRushHour = ref(false);
    const isEveningRushHour = ref(false);
    return {
      noQueryAddress,
      map,
      geolocation,
      geocoder,
      vehicleTypes,
      vehiclePrices,
      tolls,
      weather,
      driving,
      position,
      cityName,
      cityCode,
      lastCityCode,
      orderCityCode,
      showWeather,
      cityWeather,
      cityWeatherIcon,
      userData,
      calling,
      callErrorCount,
      startAddress,
      startPosition,
      endAddress,
      endPosition,
      paidPickUp,
      kilometer,
      drivingTime,
      reserve,
      showReserveForm,
      reserveDay,
      reserveDate,
      reserveTime,
      tip,
      showTipForm,
      tipAmount,
      proxy,
      showProxyForm,
      proxyPriorityContactPassenger,
      proxyPassengerMobile,
      proxyPassengerName,
      setting,
      isMorningRushHour,
      isEveningRushHour
    };
  },
  mounted() {
    const that = this;
    setTimeout(function () {
      //DOM初始化完成进行地图初始化
      that.initMap();
    }, 250);
    // //早晚高峰判断时间
    // const peakHoursDate = new Date();
    // //判断是否为早高峰
    // this.isMorningRushHour = (peakHoursDate.getHours() === 7)
    //     || (peakHoursDate.getHours() === 8 && peakHoursDate.getMinutes() <= 30);
    // //判断是否为晚高峰
    // this.isEveningRushHour = (peakHoursDate.getHours() === 16 && peakHoursDate.getMinutes() >= 30)
    //     || (peakHoursDate.getHours() === 17 && peakHoursDate.getMinutes() <= 30);
    // if (this.isMorningRushHour || this.isEveningRushHour) {
    //   this.vehicleTypes['ORDER_CAR_TYPE_NORMAL_TAXI'].checked = true;
    //   this.vehicleTypes['ORDER_CAR_TYPE_ONLINE_TAXI'].checked = false;
    //   this.vehicleTypes['ORDER_CAR_TYPE_NORMAL_TAXI'].disabled = false;
    //   this.vehicleTypes['ORDER_CAR_TYPE_ONLINE_TAXI'].disabled = true;
    // }
    SettingApi.getSetting().then(function (result) {
      if (result.setting) {
        that.setting = result.setting;
        if (that.setting && that.setting.orderCarTypes) {
          for (const key in that.setting.orderCarTypes) {
            that.vehicleTypes[key].checked = that.setting.orderCarTypes[key];
          }
        } else {
          that.vehicleTypes['ORDER_CAR_TYPE_ONLINE_TAXI'].checked = true;
        }
      } else {
        that.vehicleTypes['ORDER_CAR_TYPE_ONLINE_TAXI'].checked = true;
      }
      if (that.isMorningRushHour || that.isEveningRushHour) {
        that.vehicleTypes['ORDER_CAR_TYPE_NORMAL_TAXI'].checked = true;
        that.vehicleTypes['ORDER_CAR_TYPE_ONLINE_TAXI'].checked = false;
        that.vehicleTypes['ORDER_CAR_TYPE_NORMAL_TAXI'].disabled = false;
        that.vehicleTypes['ORDER_CAR_TYPE_ONLINE_TAXI'].disabled = true;
      }
    }).catch(function (error) {
      // that.vehicleTypes[1].checked = true;
    });
    try {
      const orderInitiateData = StorageUtil.getObject('orderInitiateData');
      if (orderInitiateData) {
        this.orderCityCode = orderInitiateData.orderCityCode;
        this.startAddress = orderInitiateData.startAddress;
        this.startPosition = orderInitiateData.startPosition;
        this.endAddress = orderInitiateData.endAddress;
        this.endPosition = orderInitiateData.endPosition;
        this.reserve = orderInitiateData.reserve;
        this.reserveDay = orderInitiateData.reserveDay;
        this.reserveDate = orderInitiateData.reserveDate;
        this.reserveTime = orderInitiateData.reserveTime;
        this.proxy = orderInitiateData.proxy;
        this.proxyPriorityContactPassenger = orderInitiateData.proxyPriorityContactPassenger;
        this.proxyPassengerMobile = orderInitiateData.proxyPassengerMobile;
        this.proxyPassengerName = orderInitiateData.proxyPassengerName;
        this.tipAmount = orderInitiateData.tipAmount;
        this.tip = orderInitiateData.tip;
        this.paidPickUp = orderInitiateData.paidPickUp;
      }
    } catch (e) {} finally {
      // StorageUtil.remove("orderInitiateData");
    }
  },
  unmounted() {
    if (this.map) {
      this.map.destroy();
    }
  },
  beforeRouteLeave() {
    StorageUtil.setObject('addressData', {
      type: 'end',
      address: '',
      position: ''
    });
  },
  methods: {
    RouterUtil() {
      return RouterUtil;
    },
    initMap() {
      const that = this;
      this.userData = StorageUtil.getObject('userData');
      window._AMapSecurityConfig = {
        securityJsCode: '23ca323d154479c363c8c8df0b1ddb92'
      };
      AMapLoader.load({
        key: Config.mapKey,
        // 申请好的Web端开发者Key，首次调用 load 时必填
        version: Config.mapVersion,
        // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
        // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        'AMap.Geocoder', 'AMap.Geolocation', 'AMap.Weather', 'AMap.Driving']
      }).then(AMap => {
        this.map = new AMap.Map('map', {
          //设置地图容器ID
          viewMode: '2D',
          //是否为3D地图模式
          zoom: 16,
          //初始化地图级别
          center: this.position //初始化地图中心点位置
          // mapStyle: "amap://styles/macaron",   //地图样式
        });
        this.geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          //是否使用高精度定位，默认:true
          timeout: 10000,
          //超过10秒后停止定位，默认：5s
          //position: 'RB',                         //定位按钮的停靠位置
          //offset: [10, 20],                       //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
          zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
        });
        this.geocoder = new AMap.Geocoder({
          // city: "010",                            //城市设为北京，默认：“全国”
          // radius: 1000                            //范围，默认：500
        });
        this.weather = new AMap.Weather();
        this.driving = new AMap.Driving({
          map: this.map,
          //驾车策略，包括 LEAST_TIME，LEAST_FEE, LEAST_DISTANCE, REAL_TRAFFIC
          // policy: AMap.DrivingPolicy.LEAST_TIME,
          // autoFitView: false,
          // panel: "panel"
          policy: '2',
          extensions: 'all'
        });
        this.map.on('moveend', function () {
          that.position = that.map.getCenter();
          if (!that.noQueryAddress) {
            that.getAddress(that.position);
          }
          that.noQueryAddress = false;
        });
        this.getDriving();
        this.getAddress(this.position);
        this.getCurrentPosition();
      }).catch(e => {
        console.error(e);
      });
    },
    getCurrentPosition() {
      const that = this;
      try {
        this.geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete') {
            that.position = result.position;
          } else {
            that.position = Config.defaultPosition;
          }
          // that.map.setCenter(that.position);
          that.getAddress(that.position);
        });
      } catch (e) {
        that.position = Config.defaultPosition;
        // that.map.setCenter(that.position);
        that.getAddress(that.position);
      }
    },
    getAddress(position) {
      const that = this;
      this.geocoder.getAddress(position, function (status, result) {
        if (status === 'complete' && result.regeocode) {
          const addressComponent = result.regeocode.addressComponent;
          const formattedAddress = result.regeocode.formattedAddress;
          const showAddress = formattedAddress.replace(addressComponent.province, '').replace(addressComponent.city, '').replace(addressComponent.district, '').replace(addressComponent.township, '');
          // console.error(showAddress);
          that.cityCode = addressComponent.adcode;
          that.cityName = addressComponent.district.length > 0 && (addressComponent.district.indexOf('市') > 0 || addressComponent.district.indexOf('县') > 0) ? addressComponent.district : addressComponent.city;
          if (that.cityCode !== that.lastCityCode) {
            that.getWeather(that.cityCode);
          }
          //that.lastCityCode = that.cityCode;
          if (that.cityName.length < 1) {
            that.cityName = '未知地区';
          }
        } else {
          that.cityName = '未知地区';
          console.error('根据经纬度查询地址失败：' + status);
        }
      });
    },
    getWeather(cityCode) {
      const that = this;
      that.weather.getLive(cityCode, function (err, data) {
        if (!err) {
          if (data.weather && data.temperature) {
            that.showWeather = true;
            that.cityWeather = data.temperature + '℃';
            that.cityWeatherIcon = AssetsUtil.getWeatherIcon(data.weather);
          } else {
            that.showWeather = false;
          }
        } else {
          that.showWeather = false;
        }
      });
    },
    getDriving() {
      const that = this;
      this.driving.search(this.startPosition, this.endPosition, function (status, result) {
        // result 即是对应的驾车导航信息，相关数据结构文档请参考：https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
        if (status === 'complete') {
          if (result.routes) {
            const routes = result.routes;
            if (routes.length > 0) {
              const route = routes[0];
              const distance = parseFloat(route.distance);
              // const tolls = parseFloat(route.tolls);
              that.kilometer = parseFloat(distance / 1000.00);
              that.drivingTime = route.time;
              that.tolls = parseFloat(route.tolls);
              const tolls = that.tolls;
              let serverValuation = true;
              if (serverValuation) {
                OrderApi.getFuturePrices('NORMAL_ORDER', {
                  orderBeginAddressLongitude: that.startPosition[0],
                  orderBeginAddressLatitude: that.startPosition[1],
                  orderTargetAddressLongitude: that.endPosition[0],
                  orderTargetAddressLatitude: that.endPosition[1]
                }, that.orderCityCode).then(function (result) {
                  if (result.data) {
                    // for (let i = 0; i < result.data.data.length; i++) {
                    //   const futureData = result.data.data[i];
                    //   that.vehiclePrices[futureData.type] = futureData.cost + tolls;
                    // }
                    that.vehiclePrices['ORDER_CAR_TYPE_NORMAL_TAXI'] = result.data.data[0].cost + tolls;
                    if (result.data.data[0].promotions) {
                      that.vehicleTypes['ORDER_CAR_TYPE_NORMAL_TAXI'].promotions = true;
                      const promotions = JSON.parse(result.data.data[0].promotions);
                      that.vehicleTypes['ORDER_CAR_TYPE_NORMAL_TAXI'].promotionalDiscounts = promotions.total_price_discount * 10 + '折';
                      that.vehiclePrices['ORDER_CAR_TYPE_NORMAL_TAXI'] = result.data.data[0].promotionalCost + tolls;
                    }
                    that.$forceUpdate();
                  }
                });
              }
              if (!serverValuation) {
                // let amount = 7.00;
                // let valuationMileage = that.kilometer - 1.5;
                // let additionalMileage = valuationMileage - 2.1;
                //
                // if (valuationMileage > 0) {
                //     if (valuationMileage > 2.1) {
                //         amount += 2.1 * 2.0;
                //         amount += additionalMileage * (2.00 * 1.4);
                //     } else {
                //         amount += valuationMileage * 2.0;
                //     }
                // }

                // let amount = 7 + (that.kilometer - 1.50) * 2.0 + (that.kilometer - 2.1) * 2.0 * 0.4;
                //
                // for (let i = 0; i < that.vehicleTypes.length; i++) {
                //   // that.vehiclePrices[i] = (amount * that.vehicleTypes[i].discount).toFixed(2);
                //   that.vehiclePrices[i] = (amount * that.vehicleTypes[i].discount + tolls).toFixed(2);
                // }

                let amount = result.taxi_cost;
                const tolls = 0;

                // for (let i = 0; i < that.vehicleTypes.length; i++) {
                //   if (that.vehicleTypes[i].discount < 1) {
                //     that.vehiclePrices[i] = (amount * that.vehicleTypes[i].discount + tolls - 1).toFixed(2);
                //   } else {
                //     that.vehiclePrices[i] = (amount * that.vehicleTypes[i].discount + tolls).toFixed(2);
                //   }
                // }
                that.vehiclePrices['ORDER_CAR_TYPE_NORMAL_TAXI'] = amount + tolls;
                that.$forceUpdate();
              }
            }
          }
          setTimeout(function () {
            that.map.setFitView(null, false, [120, 64, 120, 64]);
          }, 500);
        } else {
          console.error('获取驾车数据失败：' + result);
        }
      });
    },
    checkVehicleType(index) {
      this.vehicleTypes[index].checked = !this.vehicleTypes[index].checked;
      this.$forceUpdate();
    },
    goAddress(type) {
      StorageUtil.setObject('positionData', {
        type: type,
        position: this.position
      });
      this.$router.push('/address');
    },
    goBack() {
      RouterUtil.back();
    },
    reserveNowClick() {
      this.reserve = false;
      this.showReserveForm = false;
    },
    reserveEnterClick(reserveDay, reserveTime, reserveDate) {
      this.reserveDay = reserveDay;
      this.reserveTime = reserveTime;
      this.reserveDate = reserveDate;
      this.reserve = true;
      this.showReserveForm = false;
      StorageUtil.setObjectAttr('orderInitiateData', 'reserveDay', this.reserveDay);
      StorageUtil.setObjectAttr('orderInitiateData', 'reserveTime', this.reserveTime);
      StorageUtil.setObjectAttr('orderInitiateData', 'reserveDate', this.reserveDate);
      StorageUtil.setObjectAttr('orderInitiateData', 'reserve', this.reserve);
    },
    tipCancelClick() {
      this.tip = false;
      this.showTipForm = false;
    },
    tipEnterClick(amount) {
      this.tipAmount = amount;
      this.tip = true;
      this.showTipForm = false;
      StorageUtil.setObjectAttr('orderInitiateData', 'tip', this.tip);
      StorageUtil.setObjectAttr('orderInitiateData', 'tipAmount', this.tipAmount);
    },
    proxySelfClick() {
      this.proxy = false;
      this.showProxyForm = false;
    },
    proxyEnterClick(proxyPriorityContactPassenger, proxyPassengerMobile, proxyPassengerName) {
      this.proxyPriorityContactPassenger = proxyPriorityContactPassenger;
      this.proxyPassengerMobile = proxyPassengerMobile;
      this.proxyPassengerName = proxyPassengerName;
      this.proxy = true;
      this.showProxyForm = false;
      StorageUtil.setObjectAttr('orderInitiateData', 'proxyPriorityContactPassenger', this.proxyPriorityContactPassenger);
      StorageUtil.setObjectAttr('orderInitiateData', 'proxyPassengerMobile', this.proxyPassengerMobile);
      StorageUtil.setObjectAttr('orderInitiateData', 'proxyPassengerName', this.proxyPassengerName);
      StorageUtil.setObjectAttr('orderInitiateData', 'proxy', this.proxy);
    },
    clickShowReserveForm() {
      this.showReserveForm = !this.showReserveForm;
    },
    clickShowTipForm() {
      this.showTipForm = !this.showTipForm;
    },
    clickShowProxyForm() {
      this.showProxyForm = !this.showProxyForm;
    },
    clickRidePreference() {
      RouterUtil.go('/setting/ride-preference', false, this.$route.path);
    },
    submitCall() {
      const that = this;
      if (!SessionUtil.isLogin()) {
        RouterUtil.go('/login', false, this.$route.path);
        return;
      }
      this.calling = true;
      setTimeout(function () {
        that.doCall();
      }, 500);
    },
    doCall() {
      const that = this;
      OrderApi.submitOrder({
        coordinate_type: 'GCJ02',
        order_type: that.reserve ? 'RESERVATION' : 'REALTIME',
        area_code: that.orderCityCode,
        coupon_id: null,
        passenger_name: '匿名',
        passenger_phone_number: that.userData.phone_number,
        passenger_postscript: '',
        departure_address: that.startAddress,
        departure_address_longitude: that.startPosition[0],
        departure_address_latitude: that.startPosition[1],
        destination_address: that.endAddress,
        destination_address_longitude: that.endPosition[0],
        destination_address_latitude: that.endPosition[1],
        order_car_types: that.getVehicleType(),
        dispatch_fee: that.tip ? that.tipAmount : null,
        estimated_distance: that.kilometer,
        estimated_duration: parseInt(that.drivingTime / 60),
        estimated_cost: that.getEstimatePrice(),
        estimated_tolls: null,
        flight_number: null,
        paid_pick_up: that.paidPickUp ? 1 : 0,
        dispatch_task: null,
        behalf_of: that.proxy ? 1 : 0,
        behalf_of_first_contact: that.proxyPriorityContactPassenger ? 1 : 0,
        behalf_of_passenger_name: that.proxyPassengerName && that.proxyPassengerName.length > 0 ? that.proxyPassengerName : '匿名',
        behalf_of_passenger_phone_number: that.proxyPassengerMobile,
        carried_cargo: null,
        car_usage_time: that.reserve ? that.reserveDate + ' ' + that.reserveTime[0] + ':' + that.reserveTime[1] + ':00' : moment().format('yyyy-MM-DD HH:mm:ss')
      }).then(function (result) {
        console.log('order_number:' + result.order_number);
        if (result.order_number) {
          StorageUtil.setObject('callingData', {
            order_id: result.order_number,
            reserve: that.reserve,
            reserveDate: that.reserveDate,
            customerPhone: that.userData.phone_number,
            paidPickUp: that.paidPickUp,
            tip: that.tip,
            tipAmount: that.tipAmount,
            tolls: that.tolls,
            vehicles: {
              types: that.vehicleTypes,
              prices: that.vehiclePrices
            }
          });
          that.$router.replace('/order/calling');
        } else {
          var _result$response, _result$response2;
          let msg = '叫车失败，请重试';
          if ((_result$response = result.response) !== null && _result$response !== void 0 && (_result$response = _result$response.data) !== null && _result$response !== void 0 && _result$response.msg && ((_result$response2 = result.response) === null || _result$response2 === void 0 || (_result$response2 = _result$response2.data) === null || _result$response2 === void 0 || (_result$response2 = _result$response2.msg) === null || _result$response2 === void 0 ? void 0 : _result$response2.length) > 0) {
            msg = '叫车失败，' + result.response.data.msg;
          }
          showDialog({
            message: msg
          });
        }
      }).catch(function (error) {
        that.callErrorCount++;
        if (that.callErrorCount < 5) {
          showDialog({
            message: '叫车请求失败，请重试'
          });
        } else {
          showDialog({
            message: '叫车请求失败多次，请稍后重试或联系客服'
          });
        }
      }).finally(function () {
        that.calling = false;
      });
    },
    selectPaidPickUp() {
      if (!this.paidPickUp) {
        showConfirmDialog({
          message: '您确定需要打表来接吗？'
        }).then(() => {
          this.paidPickUp = true;
          StorageUtil.setObjectAttr('orderInitiateData', 'paidPickUp', this.paidPickUp);
        }).catch(() => {
          this.paidPickUp = false;
          StorageUtil.setObjectAttr('orderInitiateData', 'paidPickUp', this.paidPickUp);
        });
      } else {
        this.paidPickUp = false;
        StorageUtil.setObjectAttr('orderInitiateData', 'paidPickUp', this.paidPickUp);
      }
    },
    getVehicleType() {
      if (this.vehicleTypes) {
        let vt1 = this.vehicleTypes['ORDER_CAR_TYPE_NORMAL_TAXI'].checked;
        // let vt2 = this.vehicleTypes['ORDER_CAR_TYPE_ONLINE_TAXI'].checked;
        let vt2 = false;
        if (!vt1 && !vt2) {
          return null;
        }
        if (vt1 && !vt2) {
          return 'ORDER_CAR_TYPE_NORMAL_TAXI';
        }
        if (!vt1 && vt2) {
          return 'ORDER_CAR_TYPE_ONLINE_TAXI';
        }
        if (vt1 && vt2) {
          return 'ORDER_CAR_TYPE_NORMAL_TAXI,ORDER_CAR_TYPE_ONLINE_TAXI';
        }
      } else {
        return null;
      }
    },
    getEstimatePrice() {
      if (this.vehicleTypes['ORDER_CAR_TYPE_NORMAL_TAXI'].checked) {
        return this.vehiclePrices['ORDER_CAR_TYPE_NORMAL_TAXI'];
      }
      return 0;
    },
    getPassengerPhone() {
      if (this.proxy) {
        return this.proxyPassengerMobile;
      } else {
        return this.userData.phone_number;
      }
    },
    getPassengerName() {
      if (this.proxy) {
        return this.proxyPassengerName && this.proxyPassengerName.length > 0 ? this.proxyPassengerName : '匿名';
      } else {
        return '匿名';
      }
    }
  }
};